'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.ITPurchasing', [])

.factory('ITPurchasingService', ['$http', '$q', function ($http, $q) {

    var service = {};

    var baseUrl = environment.apiUrl + '/ID/ITPurchasing/API';

    // HttpGet
    service.getAllSystemEmployeeWithSignificantCost = function (keywords, status, afterUserAccessRequestID, withMyRequests) {
        var keywordsToSearch = keywords;
        if (_.isUndefined(keywords) || _.isNull(keywords)) keywordsToSearch = '';

        var statusToSearch = status;
        if (_.isUndefined(status) || _.isNull(status)) statusToSearch = '';

        var afterRequestIDToSearch = afterUserAccessRequestID;
        if (_.isUndefined(afterUserAccessRequestID) || _.isNull(afterUserAccessRequestID)) afterRequestIDToSearch = '';

        return $http.get(baseUrl + '/GetAllSystemEmployeeWithSignificantCost?' +
                         'keywords=' + keywordsToSearch +
                         '&status=' + statusToSearch +
                         '&afterUserAccessRequestID=' + afterRequestIDToSearch +
                         '&withMyRequests=' + (withMyRequests ? 1 : 0))
                    .then(function (response) {
                        return response.data;
                    });
    }

    // HttpPost
    service.getExistingSystemRoles = function (systemEmployee) {
        return $http.post(baseUrl + '/GetExistingSystemRoles',
                          { systemEmployee: systemEmployee })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.authorizeSignificantCost = function (systemEmployee) {
        return $http.post(baseUrl + '/AuthorizeSystemEmployeeWithSignificantCost',
                          { systemEmployee: systemEmployee })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.saveSignificantCost = function (systemEmployee) {
        return $http.post(baseUrl + '/SaveSignificantCost',
                          { systemEmployee: systemEmployee })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.assignToCurrentUser = function (systemEmployee) {
        return $http.post(baseUrl + '/AssignToCurrentUser',
                          { systemEmployee: systemEmployee })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.assignToEmployee = function (systemEmployee, employeeId) {
        return $http.post(baseUrl + '/AssignToEmployee',
                          {
                              systemEmployee: systemEmployee,
                              employeeId: employeeId
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
